export class Semaphore {
  private available: number
  private readonly queue: Array<() => void> = []

  constructor(private readonly maxPermits: number = 1) {
    this.available = maxPermits
  }

  acquire(): Promise<void> {
    return new Promise((resolve) => {
      if (this.available > 0) {
        this.available -= 1
        resolve()
        return
      }

      this.queue.push(resolve)
    })
  }

  release(): void {
    const next = this.queue.shift()
    if (next) {
      next()
      return
    }

    if (this.available < this.maxPermits) {
      this.available += 1
    }
  }
}
